module.exports = __webpack_public_path__ + "img/characterAnime03.f8aae6c4.png";